export default function requiresCMHCInsurance(propertyValue, downPayment) {
    if (propertyValue >= 1000000) {
        return false;
    }
    
    return downPayment < propertyValue * 0.2;
}